import type { IconSvgObject } from './types';

const CurvyUpDownDirectionIcon: IconSvgObject = [
  ["path", { d: "M11 22L11 18C11 16.8954 11.8954 16 13 16H17C18.1046 16 19 15.1046 19 14C19 12.8954 18.1046 12 17 12H6.99583C5.89356 12 5 11.1064 5 10.0042C5 8.89865 5.89865 8.00375 7.00415 8.00836L10.9916 8.02499C12.0995 8.02961 13 7.13284 13 6.02501L13 2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M11 4L13 2L15 4", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M9 20L11 22L13 20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default CurvyUpDownDirectionIcon;
